import _ from 'lodash'
import Schema from 'schema-dts'
import slugify from 'slugify'
import { JsonLd } from 'react-schemaorg'
import { Vendor } from '@cruz-com/lookup'
import { webBaseUrl } from '@/settings'

export const DealerLocationSchema = ({ dealerLocation }: { dealerLocation: Vendor.Location | any }) => {
  try {
    if (!dealerLocation || _.isEmpty(dealerLocation)) {
      return <></>
    }

    const { _id, name, address1, city, state_abbr, zip_code, phone, place } = dealerLocation

    if (!name) {
      return <></>
    }

    function getAddress() {
      if (place?.full_address) {
        const x = place.full_address.split(', ')
        const address = _.dropRight(x, 2).join(', ')
        return address
      }
      return address1
    }

    const d: Schema.WithContext<Schema.AutoDealer> = {
      '@context': 'https://schema.org',
      '@type': 'AutoDealer',
      name: name,
      address: {
        '@type': 'PostalAddress',
        streetAddress: getAddress(),
        addressLocality: city,
        addressRegion: state_abbr,
        postalCode: zip_code,
        addressCountry: 'US',
      },
      telephone: phone,
      currenciesAccepted: 'USD',
      url: `${webBaseUrl}/vehicles/dealer/${slugify(name)}/${slugify([city, state_abbr, zip_code].join(' '))}/${_id}`
    }

    return (
      <JsonLd<Schema.AutoDealer> key={_id as string} item={d} />
    )
  } catch {
    return <></>
  }
}